import { Injectable } from '@angular/core';
import { ToastrService, ToastrConfig, IndividualConfig } from 'ngx-toastr';
import { Subject } from 'rxjs';

type Severities = 'success' | 'info' | 'warning' | 'error';

export interface Message {
  severity: Severities;
  summary: string;
  detail: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private options: Partial<IndividualConfig> = {
    timeOut: 4000,
    closeButton: true,
    enableHtml: true,
    toastClass: 'alert alert-primary alert-with-icon',
    positionClass: 'toast-top-right'
  };

  constructor(private toastr: ToastrService) {}

  public notify(severity: Severities, summary: string, detail = '') {
    if (!this.toastr) {
      return Promise.resolve();
    }

    this.toastr.show(`<span class="now-ui-icons ui-1_bell-53"></span>`, summary + ': ' + detail, this.options, severity);
    return Promise.resolve();
  }
}
